import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/bangkok/gasless-nft-claims.png")